import React from 'react';
import { Text } from '@amzn/stencil-react-components/text';
import { Expander } from '@amzn/stencil-react-components/expander';

export const QualitySupportCurrentWeekFAQSet: React.FunctionComponent = () => {
  return (
    <>
      <Expander titleText="What is DPMO?">
        <Text>
          Defects Per Million Opportunities is the primary Quality metric used to evaluate quality performance. This ratio shows how many errors would occur across one million transactions.
        </Text>
      </Expander>
      <Expander titleText="What is an Overage?">
        <Text>
          An Overage is said to occur when there is a discrepancy in inventory such that an item is present physically but not virtually.
        </Text>
      </Expander>
      <Expander titleText="What is a Shortage?">
        <Text>
          An Shortage is said to occur when there is a discrepancy in inventory such that an item is present virtually but not physically.
        </Text>
      </Expander>
    </>
  );
}